import type { Dispatch, SetStateAction } from 'react';
import { ANY_AGE_VALUE } from '../../../../../../../modules/audiences/AudienceForm/components/AudienceCriteria/hooks/useDemographicsOptions.ts';
import type { FormSegment } from '../../../../../../../modules/audiences/AudienceForm/types.ts';
import type { AgeType } from '../../hooks/useDemographicsOptions.ts';

export type HandleAddAgeGroupProps = {
  minAge: number;
  maxAge: number;
  rangeToSegments: (ageRange: AgeType) => FormSegment[];
  selectedAgeSegments: FormSegment[];
  setSelectedAgeSegments: Dispatch<SetStateAction<FormSegment[]>>;
  setMinAge: Dispatch<SetStateAction<number>>;
  setMaxAge: Dispatch<SetStateAction<number>>;
};

export const handleAddAgeGroup = ({
  minAge,
  maxAge,
  rangeToSegments,
  selectedAgeSegments,
  setSelectedAgeSegments,
  setMinAge,
  setMaxAge,
}: HandleAddAgeGroupProps) => {
  if (minAge === ANY_AGE_VALUE || maxAge === ANY_AGE_VALUE) {
    return;
  }

  const newSegments = rangeToSegments({ min: minAge, max: maxAge });

  if (selectedAgeSegments.length) {
    const selectedSegmentMap = new Map(selectedAgeSegments.map(segment => [segment.id, segment]));

    for (const segment of newSegments) {
      selectedSegmentMap.delete(segment.id);
    }

    for (const segment of selectedSegmentMap.values()) {
      newSegments.push(segment);
    }
  }
  setSelectedAgeSegments(newSegments);
  setMinAge(ANY_AGE_VALUE);
  setMaxAge(ANY_AGE_VALUE);
};
